"use strict";
import Swiper from 'swiper/bundle';

let swiper;
let swipeOption = {
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
  slidesPerView: 2,
  centeredSlides: true,
  loop: true,
  pagination: {
    el: '.swiper-pagination',
		type: 'bullets',
		clickable: true,
  },
}


document.addEventListener(
  "DOMContentLoaded",
  () => {
    if(window.innerWidth < 768) {
      swiper =  new Swiper('.swiper-container', swipeOption);
    }
  },
  false
);

window.addEventListener(
  "resize",
  () => {
    if(window.innerWidth < 768) {
      if(swiper == undefined) swiper =  new Swiper('.swiper-container', swipeOption);
    }
  },
  false
);

